<template>
  <v-dialog v-model="modal" persistent width="1000px">
    <v-card>
      <v-card-title> Transmettre la réponse</v-card-title>
      <v-card-text>
        <v-form ref="form" :readonly="working" @submit.stop.prevent>
          <p>
            Vous allez transmettre votre réponse. Après transmission, celle-ci ne sera
            plus modifiable.
          </p>
          <p>Voulez-vous continuer la transmission?</p>

          <a-captcha-sheet v-if="!auth" ref="captcha" v-model="captcha" />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn data-testid="valider-transmettre-reponse" color="primary" @click="transmettre" :loading="working">
          Transmettre
        </v-btn>
        <v-btn data-testid="annuler-transmettre-reponse" @click="ferme" :disabled="working"> Annuler </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import makeRules from "@/mixins/makeRules";
import copy from "@/services/copy";

export default {
  mixins: [makeRules()],

  props: {
    working: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      modal: false,
      auth: false,
      captcha: {},
    };
  },

  methods: {
    form() {
      return this.$refs.form;
    },

    ferme() {
      this.modal = false;
    },

    ouvre(auth, callback) {
      this.auth = auth;
      this.callback = callback;
      this.modal = true;

      this.$nextTick(() => {
        const captcha = this.$refs.captcha;
        if (captcha) captcha.refreshCaptcha();
        this.$refs.form.resetValidation();
      });
    },

    transmettre() {
      this.callback(copy(this.captcha));
    },
  },
};
</script>
